
















































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {
	CreatePatientVaEvent,
	CreatePatientVascularAccess,
	EditPatientVaEvent,
	EditPatientVascularAccess
} from "@/api/vascularAccess"

@Component({
	components: {}
})
export default class Patient extends AbpBase {
	@Prop() value: boolean

// {
// 	mode:'add',
// 	patient: this.data.patient,
// 	road: this.data.road,
// 	name:'通路信息'  此组件可由多处调用 不同地方调用传不同值 (通路信息,透前准备，透中护理,透析区记录并发症）
// }
	@Prop() data: any

	form: any = {}

	mounted() {
		if (this.data.mode === 'add') {
			let date = new Date()
			let hour = date.getHours()
			let minute = date.getMinutes()
			this.form = {
				inputDate: date,
				time:hour + ':' + minute
			}
		} else {
			this.form = Object.assign({}, this.data.item)
			this.form.complicationTags = this.form.complicationTag.split(',')
			this.form.reasons = this.form.reason.split(',')
			this.form.operationMethods = this.form.operationMethod.split(',')
			let date = new Date(this.form.inputDate)
			let hour = date.getHours()
			let minute = date.getMinutes()
			this.form.time = hour + ':' + minute
		}
	}

	cancel() {
		(this.$refs.roleForm as any).resetFields();
		this.$emit('cancel', false)
	}

	save() {
		(this.$refs.roleForm as any).validate(async (valid: boolean) => {
			if (valid) {
				let res
				this.form.inputDate = (this.form.inputDate as any).Format('yyyy-MM-dd') + ' '+ this.form.time
				this.form.complicationTag = this.form.complicationTags.toString()
				this.form.reason = this.form.reasons.toString()
				this.form.operationMethod = this.form.operationMethods.toString()
				this.form.eventSource = this.data.name

				if (this.data.mode === 'add') {
					this.form.patientId = this.data.patient.id
					this.form.patientVAId = this.data.road.id
					res = await CreatePatientVaEvent(this.form)
				} else {
					res = await EditPatientVaEvent(this.form)
				}
				if (res.status === 1) {
					this.$emit('saveSuccess');
				}
			}
		})
	}

	get modalTitle() {
		return (this.data.mode === 'add' ? '新增' : '编辑') +  '通路事件(并发症)'
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('cancel');
		}
	}

	roleRule = {
		// trigger: 'blur'
		inputDate: [{required: true, message: this.L('FieldIsRequired')}],
		complicationTags: [{required: true, message: this.L('FieldIsRequired')}],
		reasons: [{required: true, message: this.L('FieldIsRequired')}],
		operationMethods: [{required: true, message: this.L('FieldIsRequired')}],

	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/addOrEditEvent.vue